/* global I18n */

import intervals from "intervals"
import React, {useState, useEffect} from "react"

function BigTickingClock({pricingPath, timeLeft}) {
  const remainingTime = useCountdownEffect(timeLeft)
  const [hours, minutes, seconds] = splitTime(remainingTime)

  const secString = `0${seconds}`
  const minString = `0${minutes + (60 * hours)}`

  return (
    <div className="trial-clock">
      <div
        className="trial-clock__headline"
        dangerouslySetInnerHTML={{
          __html: I18n.t("js.ticking_trial.one_hour_trial_html", {
            url: pricingPath
          })
        }}
      />
      <div className="trial-clock__counter">
        <div className="counter counter__digit">
          {minString.slice(-2, -1)}
        </div>
        <div className="counter counter__digit">{minString.slice(-1)}</div>
        <span className="counter__delimiter">:</span>
        <div className="counter counter__digit">
          {secString.slice(-2, -1)}
        </div>
        <div className="counter counter__digit">{secString.slice(-1)}</div>
      </div>
      {remainingTime <= 0 &&
        <a className="btn btn-primary btn-big" href={pricingPath}>
          {I18n.t("js.ticking_trial.go_premium")}
        </a>}
      <div className="trial-meta-text">
        {I18n.t("js.ticking_trial.enjoy_temp_free_premium")}
        <br />
        {I18n.t("js.ticking_trial.free_forever")}
      </div>
    </div>
  )
}

function SmallTickingClock({pricingPath, timeLeft}) {
  const remainingTime = useCountdownEffect(timeLeft)
  const [hours, minutes, seconds] = splitTime(remainingTime)

  const secString = `0${seconds}`
  const minString = `0${minutes + (60 * hours)}`

  return (
    <a className="trial-clock__counter" href={pricingPath}>
      <span className="counter__digit">
        {minString.slice(-2, -1)}
      </span>
      <span className="counter__digit">{minString.slice(-1) + ":"}</span>
      <span className="counter__digit">
        {secString.slice(-2, -1)}
      </span>
      <span className="counter__digit">{secString.slice(-1)}</span>
      {" "}
      <span>{I18n.t("js.ticking_trial.of_trial_remaining")}</span>
    </a>
  )
}

function LongTickingClock({timeLeft}) {
  const remainingTime = useCountdownEffect(timeLeft)
  const [hours, minutes, seconds] = splitTime(remainingTime)

  return (
    <div className="time">
      <span className="number">{hours}</span>
      <span className="marker">h</span>
      <span className="number">{minutes}</span>
      <span className="marker">m</span>
      <span className="number">{seconds}</span>
      <span className="marker">s</span>
    </div>
  )
}

function splitTime(time) {
  if (!time || time < 0) return [0, 0, 0]

  const seconds = Math.floor(time / 1000) % 60
  const minutes = Math.floor(time / 1000 / 60) % 60
  const hours = Math.floor(time / 1000 / 60 / 60) % 60
  return [hours, minutes, seconds]
}

// based on https://alligator.io/react/countdown-timer-react-hooks/
//
// there's a more robust implementation from Dan Abramov from the React team
// at https://overreacted.io/making-setinterval-declarative-with-react-hooks/
// but it felt like a bit of an overkill ... no need to change intervals :)
function useCountdownEffect(timeLeft) {
  const [remainingTime, setRemainingTime] = useState(timeLeft)
  useEffect(() => {
    if (remainingTime <= 0) return null

    const interval = intervals.set(
      () => setRemainingTime(remainingTime - 1000),
      1000
    )
    return () => clearInterval(interval)
  }, [remainingTime])
  return remainingTime
}

export {SmallTickingClock, BigTickingClock, LongTickingClock}
